import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-input-error-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-input-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import Handlebars from '@sparta.global.vendors/handlebars';
import { textInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <style type=\"text/css\">\r\n    .image.faq-text {\r\n      background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"paper") : depth0)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + ");\r\n    }\r\n\r\n    .image.question-bubble {\r\n      background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"question") : depth0)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + ");\r\n    }\r\n  </style>\r\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n  <div class=\"flex-container "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"bottom") : depth0)) != null ? lookupProperty(stack1,"line") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":29},"end":{"line":15,"column":67}}})) != null ? stack1 : "")
    + "\">\r\n    <div class=\"flex-item-1\"></div>\r\n    <div class=\"flex-item-3 left\">\r\n      <h3 class=\"image question-bubble\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"left") : depth0)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"left") : depth0)) != null ? lookupProperty(stack1,"items") : stack1),{"name":"each","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":8},"end":{"line":22,"column":17}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"left") : depth0)) != null ? lookupProperty(stack1,"cta") : stack1),{"name":"each","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":8},"end":{"line":26,"column":17}}})) != null ? stack1 : "")
    + "\r\n      </ul>\r\n    </div>\r\n    <div class=\"flex-item-1\"></div>\r\n    <div class=\"flex-item-3\">\r\n      <h3>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"right") : depth0)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"right") : depth0)) != null ? lookupProperty(stack1,"items") : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":6},"end":{"line":82,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n    <div class=\"flex-item-1\"></div>\r\n  </div>\r\n\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    return " bottom-line";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <li> "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0)) != null ? stack1 : "")
    + " </li>\r\n";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <ul class=\"main\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"right") : depth0)) != null ? lookupProperty(stack1,"items") : stack1),{"name":"each","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":10},"end":{"line":76,"column":19}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"right") : depth0)) != null ? lookupProperty(stack1,"cta") : stack1),{"name":"each","hash":{},"fn":container.program(25, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":78,"column":10},"end":{"line":80,"column":19}}})) != null ? stack1 : "")
    + "        </ul>\r\n";
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),{"name":"unless","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":12},"end":{"line":40,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","image-li",{"name":"compare","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":12},"end":{"line":52,"column":24}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","input-li",{"name":"compare","hash":{},"fn":container.program(20, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":53,"column":12},"end":{"line":75,"column":24}}})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li class=\"image faq-text "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"class") || (depth0 != null ? lookupProperty(depth0,"class") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"class","hash":{},"data":data,"loc":{"start":{"line":37,"column":40},"end":{"line":37,"column":49}}}) : helper)))
    + "\">\r\n                <p>"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"p") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":19},"end":{"line":38,"column":60}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n              </li>\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"p") : depth0), depth0)) != null ? stack1 : "")
    + " <br/> ";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"imgnode") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":18},"end":{"line":42,"column":62}}})) != null ? stack1 : "")
    + ">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"imgnode") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":16},"end":{"line":45,"column":23}}})) != null ? stack1 : "")
    + "                <div class=\"content\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"text") : depth0),{"name":"each","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":18},"end":{"line":49,"column":27}}})) != null ? stack1 : "")
    + "                </div>\r\n              </li>\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    return "class=\"contains-image\"";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <img src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"imgnode") : depth0)) != null ? lookupProperty(stack1,"img") : stack1), depth0))
    + "\" alt=\"\" aria-hidden=\"true\"/>\r\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <p>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"20":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li class=\"input-li\">\r\n                <form id=\""
    + container.escapeExpression(container.lambda((container.data(data, 1) && lookupProperty(container.data(data, 1),"key")), depth0))
    + "-form\" novalidate>\r\n                  <div class=\"row collapse form-wrapper\">\r\n                    <div class=\"small-7 medium-7 large-6 column\">\r\n                      "
    + container.escapeExpression((lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cityStateInput") : depth0),{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":58,"column":22},"end":{"line":58,"column":52}}}))
    + "\r\n                    </div>\r\n                    <div class=\"small-5 medium-5 large-6 column\">\r\n                      <a tabindex=\"0\"\r\n                        href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"href") : stack1), depth0))
    + "\"\r\n                        class=\"spa-btn spa-btn--primary spa-btn--medium "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"class") : stack1), depth0))
    + "\"\r\n                        "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"data") : stack1),{"name":"if","hash":{},"fn":container.program(21, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":64,"column":24},"end":{"line":64,"column":80}}})) != null ? stack1 : "")
    + "\r\n                        id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "\">\r\n                        "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"text") : stack1), depth0))
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"ada") : stack1),{"name":"if","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":67,"column":24},"end":{"line":69,"column":31}}})) != null ? stack1 : "")
    + "                      </a>\r\n                    </div>\r\n                  </div>\r\n                </form>\r\n              </li>\r\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-options=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"data") : stack1), depth0))
    + "\"";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <span class=\"ada-hidden\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"ada") : stack1), depth0))
    + "</span>\r\n";
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li> "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0)) != null ? stack1 : "")
    + " </li>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"icons") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":11,"column":9}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":0},"end":{"line":87,"column":9}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/top-faq-module",
  "version": "1.0.8",
  "id": "topFaqModule",
  "containerID": "homeLoansTopFaqModule",
  "moduleName": "home-loans-top-faq-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "top-faq-module",
  "data": {
    "init": "topFaqModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "scope",
    "type": "string",
    "default": "",
    "description": ""
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        textInput,
        compare
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    textInput,
    compare
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-validation-framework-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.global.utilities/sparta-input-error-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-input-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @export
 * @class topFaqModule
 * @extends {Module}
 */
class topFaqModule extends Module {
  /**
  * Creates an instance of topFaqModule.
  * @param {Object} options Module Options
  * @param {Object} context Module context
  * @memberof topFaqModule
  */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    // Jquery object for wrapper
    this.$target = $('#topFaqModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method submitFindAHome
   * @param {Object} e event handler
   * @desc reads in city and state and forwards to page with query parm of city and state
   * @returns {void}
   */
  validateInput(e) {
    e.preventDefault();
    const $input = this.settings.$target.find(e.currentTarget);
    const $submit = $('.topFaqModule #-form a');
    const cityState = $input.val().trim();
    const hasInterstitial = !!$submit.attr('data-options');

    // Set $submit href back to javascript:void(0) if user invalidates form
    // eslint-disable-next-line no-script-url
    $submit.attr('href', 'javascript:void(0)');

    // Remove required interstial classes to prevent interstitial
    // from being able to be fired if user invalidates form
    if (hasInterstitial) $submit[0].classList.remove('spa-ui-layer-link', 'spa-fn');

    // ensure we are validated
    const isValidRequired = this.validationCore.validateRequiredFields($input);
    const isValidRules = this.validationCore.validateRules($input, this.validationRules[$input.attr('id')].change);
    if (!isValidRequired || !isValidRules) {
      return;
    }
    const arr = cityState.split(',');

    // double check to ensure we have a comma
    if (arr.length === 1) {
      return;
    }

    // last element is state
    const state = arr[arr.length - 1].trim().toUpperCase();

    // delete last element and city is rest of array
    arr.pop();
    const city = arr.join(',').trim().toUpperCase();

    // construct url
    const parm = `?city=${encodeURI(city)}&state=${encodeURI(state)}`;

    // get url
    const url = $input.attr('data-url');

    // turn on interstitial
    if (hasInterstitial) $submit[0].classList.add('spa-ui-layer-link', 'spa-fn');

    // Update submit URL
    $submit.attr('href', url + parm);
  }

  /**
   * @method initializeValidation
   * @return {void}
   */
  initializeValidation() {
    this.validationRules = _.fromPairs(this.settings.$target.find('[data-validation-rules]').map(function rulesMap() {
      const $this = $(this);
      return [[$this.attr('id'), $this.data('validation-rules')]];
    }));
    this.validationCore = spartaValidationFramework.fn.core;
    this.validationCore.bindValidationRules(this.validationRules, true);
  }

  /**
  * @memberof topFaqModule
  * @returns {void}
  */
  init() {
    const {
      $target
    } = this.settings;
    $target.spartaInputs();
    this.initializeValidation();
    spartaValidationFramework.init();

    // Validate user input on keyup
    this.settings.$target.find('#-form #changeZipCodeInputMortgage').off().on('keyup', this.validateInput);
    this.settings.$target.find('form').off().on('submit', e => {
      e.preventDefault();
      this.settings.$target.find('.spa-btn').trigger('click');
    });
  }
}
registerModuleClass({
  moduleClass: topFaqModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { topFaqModule as default, moduleConfig };
